import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/funnelChart";
import { useDispatch, useSelector } from "react-redux";

export const GroupObjectsFilter = () => {
  const dispatch = useDispatch();

  const averageGroup = useSelector((state) => state.laser.selectedFilters.averageGroup);
  const subAverageFilterOptions = useSelector((state) => state.laser.subAverageFilterOptions);
  const selectedSubAverageFilterOptions = useSelector(
    (state) => state.laser.selectedFilters.subAverageFilterOptions
  );

  const allOptions = subAverageFilterOptions[averageGroup] || [];

  if (!allOptions.length) return null;

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">{averageGroup}</p>
      <MultiSelectDropdown
        options={allOptions}
        selectedFilters={selectedSubAverageFilterOptions}
        onSelectChange={(data) => dispatch(actionCreators.setSubAverageSelectedOptions(data))}
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        haveOnSelectChange
      />
    </div>
  );
};
